import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Pipe({
    name: 'mentionFormat',
    standalone: true
})
export class MentionFormatPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(text: string): SafeHtml {
        if (!text) {
            return this.sanitizer.bypassSecurityTrustHtml('');
        }

        const regex = /(^|\s)@(\S+)/g;
        let formattedText: string = text;
        let match;

        const mentionsFound: {
            username: string,
            leadingChar: string,
            matchIndex: number,
            usernameStartIndex: number
        }[] = [];


        while ((match = regex.exec(text)) !== null) {
            const leadingChar: string = match[1];
            const username: string = match[2];

            const atUsernameStartIndex: number = match.index + leadingChar.length;

            mentionsFound.push({
                username: username,
                leadingChar: leadingChar,
                matchIndex: match.index,
                usernameStartIndex: atUsernameStartIndex
            });
        }

        mentionsFound.sort((a, b): number => b.matchIndex - a.matchIndex);

        mentionsFound.forEach(mention => {
            const replacementLength: number = 1 + mention.username.length;
            const replacementHtml: string =
                `<span class="ngx-text-highlight-tag clickable" role="button" ` +
                `aria-label="view user ${mention.username}" ` +
                `data-username="${mention.username}">@${mention.username}</span>`;
            formattedText =
                formattedText.substring(0, mention.usernameStartIndex) +
                replacementHtml +
                formattedText.substring(mention.usernameStartIndex + replacementLength);
        });

        return this.sanitizer.bypassSecurityTrustHtml(formattedText);
    }
}
